import '.d{display:flex;}.ssr-plugin'
import '.v{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.u{align-items:center;}.ssr-plugin'
import '.y{gap:0.5rem;}.ssr-plugin'
import '.ae{cursor:pointer;}.ssr-plugin'
import '.g7{padding:0.75rem;}.ssr-plugin'
import '.al{border-radius:1.25rem;}.ssr-plugin'
import '.a9{border:var(--border-subtle);}.ssr-plugin'
import '.a8{background-color:var(--palette-white);}.ssr-plugin'
import '.du{transition:background-color 0.2s ease;}.ssr-plugin'
import '.fk{width:2.5rem;}.ssr-plugin'
import '.cw{height:2.5rem;}.ssr-plugin'
import '.gr{color:var(--palette-blue-700);}.ssr-plugin'
import '.gs{font-size:0.9rem;}.ssr-plugin'
import '.a1{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d v e u y ae g7 al a9 a8 du"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="fk cw d u v gr"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="gs gr a1"
        >
          {label}
        </span>
      </styled.button>
    )
}